import { SnotifyService } from 'ng-snotify';
import { Component, OnInit, ViewChild } from '@angular/core';
import { CredenciamentoAplicativoService } from "../../services/credenciamento/aplicativo/credenciamento-aplicativo.service";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { EmpresaService } from "../../services/empresa/empresa.service";
import { NovoCadastroComponent } from "../../modal/credenciamento/aplicativo/novo-cadastro/novo-cadastro.component";

@Component({
  selector: 'app-usuario-credenciamento',
  templateUrl: './aplicativo-credenciamento.component.html',
  styleUrls: ['./aplicativo-credenciamento.component.scss']
})
export class AplicativoCredenciamentoComponent implements OnInit {

  public loading = false;

  public listaClientes:Array<any> = [];

  public lastResponse: any = null

  public perPage:number = 10

  public currentPage:number = 1

  public filter: FormGroup;

  public loadClient: any = {}

  public showClientSecret: any = {}

  public dropdownSettingsEmpresas = {
      singleSelection: false,
      idField: 'id_empresa',
      textField: 'descricao',
      itemsShowLimit: 5,
      selectAllText: 'Marcar todas',
      unSelectAllText: 'Desmarcar todas',
      allowSearchFilter: true
  };

  public empresas: Array<any> = [];

  @ViewChild('modalCadastro') modalCadastro : NovoCadastroComponent

  constructor(
      private _notify: SnotifyService,
      private credeciamentoService: CredenciamentoAplicativoService,
      private empresaService: EmpresaService,
      private fb: FormBuilder,
  )  {
  }

  ngOnInit() {
      this._initFilters()
      this._loadCredenciais();
      this._listarEmpresas();
  }

  public _loadCredenciais() {
      this.loading = true;
      this.credeciamentoService.listar(this.getFilters(), this.currentPage, this.perPage).subscribe(
          ({data}:any) => {
              this.loading = false
              this.lastResponse = data;
              this.listaClientes = this.listaClientes.concat(this.lastResponse.clientes.data)
          },
          error => {
              console.error(error)
              this.loading = false
              this._notify.error("Ocorreu um erro ao carregar empresas")
          }
      )
  }

  private _listarEmpresas(): void  {
      this.empresaService.listar(null, '', 'todos')
          .subscribe(
              ({data}) => {
                  this.empresas = data.empresas.map(empresa => {
                      return {
                          id_empresa: empresa.id_empresa,
                          descricao: `${empresa.nome} - ${empresa.cpf_cnpj}`
                      };
                  });
              },
              error => {
                  this._notify.warning('Ocorreu um erro ao carregar empresas');
              }
          );
  }

    private _initFilters() {
        this.filter = this.fb.group({
            name: new FormControl('', []),
            empresa_id: new FormControl([], []),
        });
    }

  public loadPerPage($event) {
      this.perPage = $event.target.value
      this._reset()
      this._loadCredenciais()
  }

  private _reset(): void {
      this.listaClientes = []
      this.currentPage = 1
  }

  public loadMore():void {
      this.currentPage++;
      this._loadCredenciais()
  }

  public toFilter() {
      this.reset(false);
      this._loadCredenciais();
  }

  public getFilters() {
      const filter = {};

      Object.keys(this.filter.controls).forEach((_filter) => {
          filter[_filter] = this.filter.controls[_filter].value;
      });

      if (filter['empresa_id']) {
          filter['empresa_id'] = filter['empresa_id'].map(empresa => {
              return empresa.id_empresa;
          });
      }

      return filter;
  }

  public reset(reload: boolean = false): void {
      this.listaClientes = [];
      this.currentPage = 1;

      if(reload) {
          Object.keys(this.filter.controls).forEach(key => {
              this.filter.controls[key].setValue('');
          });
          this._loadCredenciais();
      }
  }

  public deleteClient(client): void {
      if(confirm(`Tem certeza que deseja excluir o aplicativo "${client.name}"?`)) {
          this.loadClient[client.id] = true
          this.credeciamentoService.deletar(client.id).subscribe(
              (response) => {
                  this._notify.success("Aplicativo excluído com sucesso!")
                  this.reset(true)
              },
              error => {
                  this.loadClient[client.id] = false
                  this._notify.error("Erro ao excluir aplicativo!")
              }
          )
      }
  }

  public choiceShowClientSecret(clientId, show: boolean): void{
      this.showClientSecret[clientId] = show
  }
}
